import PropTypes from 'prop-types';

const ContentfulImagePropTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['auto']),
  ]).isRequired,
  description: PropTypes.string,
  title: PropTypes.string,
  additionalParams: PropTypes.shape(),
  lazyLoad: PropTypes.bool,
  breakpoints: PropTypes.arrayOf(PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['extraExtraLarge', 'extraLarge', 'large', 'medium', 'small', 'extraSmall']).isRequired,
  })),
  isLcp: PropTypes.bool,
};

const ContentfulImageDefaultProps = {
  className: '',
  description: '',
  title: '',
  width: null,
  additionalParams: {
    fm: 'webp',
  },
  lazyLoad: true,
  breakpoints: [],
  isLcp: false,
};

const ContentfulImageQueryPropTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
};

const ContentfulImageQueryDefaultProps = {
  description: '',
};

export {
  ContentfulImageDefaultProps,
  ContentfulImagePropTypes,
  ContentfulImageQueryPropTypes,
  ContentfulImageQueryDefaultProps,
};
